
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-c2880084&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./WorkOrder.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./WorkOrder.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-c2880084!../../node_modules/vue-loader/lib/selector?type=template&index=0!./WorkOrder.vue"),
  /* scopeId */
  "data-v-c2880084",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/WorkOrder.vue
// module id = 853
// module chunks = 2